import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import moment from 'moment';
import 'moment/locale/tr';
import { KTSVG } from 'src/_metronic/helpers';
import './AgreementPage.css';

// URL parametrelerini almak için yardımcı fonksiyon
const getQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    get: (param: string) => searchParams.get(param),
  };
};

const KampanyaResultPage = () => {
  // useSearchParams yerine yardımcı fonksiyon kullanıyoruz
  const searchParams = getQueryParams();
  const id = searchParams.get('id') || '';
  const agreementRef = useRef(null);

  interface Company {
    company_logo?: string;
  }

  interface User {
    company?: Company;
  }

  const [agreement, setAgreement] = useState(null);
  interface VerifyData {
    name_lastname: string;
    phone: string;
    organisation_date: string;
    areas_name: string;
    organisation_type_name: string;
    organisation_fee: number;
    note?: string;
    total_payment: number;
    remaining_payment: number;
  }

  const [verifyData, setVerifyData] = useState<VerifyData | null>(null);

  // Yeni state'ler
  const [isVerified, setIsVerified] = useState(false);
  const [verificationCode, setVerificationCode] = useState(['', '', '', '']);
  const inputRefs = [useRef<HTMLInputElement>(null), useRef<HTMLInputElement>(null), useRef<HTMLInputElement>(null), useRef<HTMLInputElement>(null)];
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

  useEffect(() => {
    if (id) {
      fetchInitialData();
    }
  }, [id]);

  const fetchInitialData = async () => {
    try {
      setLoading(true);
      const detailResponse = await fetch(REACT_APP_API_URL + `/registration/campaign/verification?id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const detailData = await detailResponse.json();
      setCountdown(300);
      detailData && setPhone(detailData.phone.slice(1));
    } catch (error) {
      console.error('Veri yüklenirken hata oluştu:', error);
      setError('Bilgiler yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let timer: any;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((current) => current - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  // Sayacı formatla
  const formatTime = (seconds: any) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleOTPChange = (index: number, value: any) => {
    if (!/^\d*$/.test(value)) return; // Sadece rakam girişine izin ver

    const newVerificationCode = [...verificationCode];
    newVerificationCode[index] = value;
    setVerificationCode(newVerificationCode);

    // Otomatik olarak sonraki input'a geç
    if (value !== '' && index < 3) {
      inputRefs[index + 1]?.current?.focus();
    }
  };

  const handleKeyDown = (index: number, e: any) => {
    // Backspace tuşuna basıldığında önceki input'a geç
    if (e.key === 'Backspace' && index > 0 && verificationCode[index] === '') {
      index && inputRefs && inputRefs[index - 1]?.current?.focus();
    }
  };

  const getCompleteVerificationCode = () => verificationCode.join('');

  const verifyCode = async () => {
    try {
      setLoading(true);
      const completeCode = getCompleteVerificationCode();
      const verifyResponse = await fetch(REACT_APP_API_URL + `/registration/campaign/verificationCode?id=${id.toLocaleString()}&code=${completeCode.toLocaleString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const responseData = await verifyResponse.json();
      const verifyData = responseData.data;
      const avaibleData = responseData.control.cs_array;
      console.log('verifyDaavaibleDatata', avaibleData);
      if (verifyData) {
        await fetch(REACT_APP_API_URL + `/registration/campaign/verificationLog?id=${id.toLocaleString()}&code=${completeCode.toLocaleString()}&success=true`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }

      setVerifyData(verifyData);
      setIsVerified(true);
      setAvailableCompanies(avaibleData); // Uygun firmaları state'e kaydet
    } catch (error) {
      const completeCode = getCompleteVerificationCode();
      await fetch(REACT_APP_API_URL + `/registration/campaign/verificationLogCampaign?id=${id.toLocaleString()}&code=${completeCode.toLocaleString()}&success=false`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setError('Doğrulama kodu hatalı');
    } finally {
      setLoading(false);
    }
  };

  const [availableCompanies, setAvailableCompanies] = useState<any[]>([]);

  return (
    <div>
      <div className="wpo-contact-form-area section-padding d-flex justify-content-center align-items-center" style={{ background: '#f8f9fa', minHeight: '100vh' }}>
        {!isVerified ? (
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="card p-4">
                  <h3 className="text-center mb-4" style={{ fontFamily: 'Poppins' }}>
                    Anlaşma Sorgulama
                  </h3>
                  {error && <div className="alert alert-danger text-center">{error}</div>}
                  <div className="form-group mb-3 d-flex flex-column align-items-center justify-content-center">
                    <label className="mb-3 text-center">
                      <span className="fw-bold text-primary">{phone ? '0' + phone : ''}</span>
                      {phone ? ' nolu ' : ''} Telefon Numaranıza Gelen Doğrulama Kodunu Giriniz.
                    </label>
                    <div className="otp-container">
                      {[0, 1, 2, 3].map((index) => (
                        <input
                          key={index}
                          ref={inputRefs[index]}
                          type="text"
                          maxLength={1}
                          className="otp-input"
                          value={verificationCode[index]}
                          onChange={(e) => handleOTPChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          autoComplete="off"
                        />
                      ))}
                    </div>
                  </div>
                  <button className="btn btn-primary w-100" onClick={verifyCode} disabled={loading || verificationCode?.join('').length !== 4}>
                    {loading ? 'Doğrulanıyor...' : 'Doğrula'}
                  </button>
                  <button
                    className="btn btn-link w-100 mt-2"
                    onClick={() => {
                      setVerificationCode(['', '', '', '']);
                      fetchInitialData();
                    }}
                    disabled={loading || countdown > 0}
                  >
                    {countdown > 0 ? `Yeni kod gönderebilmek için ${formatTime(countdown)} bekleyin` : 'Yeni Kod Gönder'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div ref={agreementRef} className="agreement-container print-only">
            <div className="text-center mb-5">
              {/* {user?.company?.company_logo && <img src={user?.company?.company_logo} alt="Logo" className="img-fluid mb-4" style={{ maxHeight: '180px', objectFit: 'contain' }} />} */}
              <div className="section-title text-center">
                <h2
                  className="mb-0 fw-bold text-primary"
                  style={{
                    fontSize: '2rem',
                    fontFamily: 'Poppins',
                  }}
                >
                  4-4'LÜK KAMPANYA TALEP BİLGİLERİ
                </h2>
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-12">
                <div className="card-custom border p-4 h-100 bg-gradient-light avoid-break">
                  <h4
                    className="section-title fw-bold text-primary"
                    style={{
                      fontSize: '1.8rem',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    Firmaların Onay Durumu
                  </h4>

                  <div className="container mt-5">
                    <div className="row">
                      {/* Feyza Organizasyon */}
                      <div className="col-md-6 col-lg-3 mb-4 d-flex justify-content-center align-items-center">
                        <div className="max-w-sm rounded overflow-hidden shadow-md d-flex flex-column justify-content-center align-items-center">
                          <img className="w-full" src="https://duguntakibi.com.tr/media/kampanya/feyza.png" alt="Feyza Organizasyon" />
                          <div className="px-6 py-4">
                            <div className="font-bold text-lg mb-2 text-center">Feyza Organizasyon</div>
                            <p className="text-gray-700 text-base text-center">Talep ettiğiniz tarihteki onay durumunuz</p>
                          </div>
                          <div className="px-2  pb-2 d-flex justify-content-center align-items-center">
                            <span
                              className={`inline-block ${
                                availableCompanies?.find((company) => company.company_code === 'Feyza')
                                  ? availableCompanies?.find((company) => company.company_code === 'Feyza')?.status
                                    ? 'bg-green-200 text-green-700'
                                    : 'bg-red-200 text-red-700'
                                  : 'bg-gray-200 text-gray-700'
                              } rounded-full px-3 py-1 text-md font-semibold  mr-2 mb-2`}
                            >
                              {availableCompanies?.find((company) => company.company_code === 'Feyza')
                                ? availableCompanies?.find((company) => company.company_code === 'Feyza')?.status
                                  ? 'Uygun'
                                  : 'Uygun değil'
                                : 'Bekleniyor'}
                            </span>

                            {availableCompanies?.find((company) => company.company_code === 'Feyza') && (
                              <>
                                <span
                                  data-tooltip-id={`tooltip-${'Feyza'}-0`}
                                  style={{ position: 'relative', top: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <KTSVG path="/media/icons/duotone/Code/Info-circle.svg" className="svg-icon-2x svg-icon-primary" />
                                </span>
                                <Tooltip
                                  id={`tooltip-${'Feyza'}-0`}
                                  content={
                                    availableCompanies?.find((company) => company.company_code === 'Feyza').note
                                      ? availableCompanies?.find((company) => company.company_code === 'Feyza').note
                                      : 'Not bulunamadı.'
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-3 mb-4 d-flex justify-content-center align-items-center">
                        <div className="max-w-sm rounded overflow-hidden shadow-md d-flex flex-column justify-content-center align-items-center">
                          <img className="w-full" src="https://duguntakibi.com.tr/media/kampanya/alya2.png" alt="Alya Rental Dress" />
                          <div className="px-6 py-4">
                            <div className="font-bold text-xl mb-2 text-center">Alya Rental Dress</div>
                            <p className="text-gray-700 text-base text-center">Talep ettiğiniz tarihteki onay durumunuz</p>
                          </div>
                          <div className="px-2  pb-2 d-flex justify-content-center align-items-center">
                            <span
                              className={`inline-block ${
                                availableCompanies?.find((company) => company.company_code === 'Alya')
                                  ? availableCompanies?.find((company) => company.company_code === 'Alya')?.status
                                    ? 'bg-green-200 text-green-700'
                                    : 'bg-red-200 text-red-700'
                                  : 'bg-gray-200 text-gray-700'
                              } rounded-full px-3 py-1 text-md font-semibold  mr-2 mb-2`}
                            >
                              {availableCompanies?.find((company) => company.company_code === 'Alya')
                                ? availableCompanies?.find((company) => company.company_code === 'Alya')?.status
                                  ? 'Uygun'
                                  : 'Uygun değil'
                                : 'Bekleniyor'}
                            </span>

                            {availableCompanies?.find((company) => company.company_code === 'Alya') && (
                              <>
                                <span
                                  data-tooltip-id={`tooltip-${'Alya'}-0`}
                                  style={{ position: 'relative', top: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <KTSVG path="/media/icons/duotone/Code/Info-circle.svg" className="svg-icon-2x svg-icon-primary" />
                                </span>
                                <Tooltip
                                  id={`tooltip-${'Alya'}-0`}
                                  content={
                                    availableCompanies?.find((company) => company.company_code === 'Alya').note
                                      ? availableCompanies?.find((company) => company.company_code === 'Alya').note
                                      : 'Not bulunamadı.'
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-3 mb-4 d-flex justify-content-center align-items-center">
                        <div className="max-w-sm rounded overflow-hidden shadow-md d-flex flex-column justify-content-center align-items-center">
                          <img className="w-full" src="https://duguntakibi.com.tr/media/kampanya/elifeylul.png" alt="Elif Eylül" />
                          <div className="px-6 py-4">
                            <div className="font-bold text-xl mb-2 text-center">Elif Eylül Makeup & Hairdress</div>
                            <p className="text-gray-700 text-base text-center">Talep ettiğiniz tarihteki onay durumunuz</p>
                          </div>
                          <div className="px-2  pb-2 d-flex justify-content-center align-items-center">
                            <span
                              className={`inline-block ${
                                availableCompanies?.find((company) => company.company_code === 'Elif Eylül')
                                  ? availableCompanies?.find((company) => company.company_code === 'Elif Eylül')?.status
                                    ? 'bg-green-200 text-green-700'
                                    : 'bg-red-200 text-red-700'
                                  : 'bg-gray-200 text-gray-700'
                              } rounded-full px-3 py-1 text-md font-semibold  mr-2 mb-2`}
                            >
                              {availableCompanies?.find((company) => company.company_code === 'Elif Eylül')
                                ? availableCompanies?.find((company) => company.company_code === 'Elif Eylül')?.status
                                  ? 'Uygun'
                                  : 'Uygun değil'
                                : 'Bekleniyor'}
                            </span>

                            {availableCompanies?.find((company) => company.company_code === 'Elif Eylül') && (
                              <>
                                <span
                                  data-tooltip-id={`tooltip-${'Elif Eylül'}-0`}
                                  style={{ position: 'relative', top: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <KTSVG path="/media/icons/duotone/Code/Info-circle.svg" className="svg-icon-2x svg-icon-primary" />
                                </span>
                                <Tooltip
                                  id={`tooltip-${'Elif Eylül'}-0`}
                                  content={
                                    availableCompanies?.find((company) => company.company_code === 'Elif Eylül').note
                                      ? availableCompanies?.find((company) => company.company_code === 'Elif Eylül').note
                                      : 'Not bulunamadı.'
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-3 mb-4 d-flex justify-content-center align-items-center">
                        <div className="max-w-sm rounded overflow-hidden shadow-md d-flex flex-column justify-content-center align-items-center">
                          <img className="w-full" src="https://duguntakibi.com.tr/media/kampanya/sinerji.png" alt="Sinerji" />
                          <div className="px-6 py-4">
                            <div className="font-bold text-lg mb-2 text-center">Sinerji Fotoğrafçılık</div>
                            <p className="text-gray-700 text-base text-center">Talep ettiğiniz tarihteki onay durumunuz</p>
                          </div>
                          <div className="px-2  pb-2 d-flex justify-content-center align-items-center">
                            <span
                              className={`inline-block ${
                                availableCompanies?.find((company) => company.company_code === 'Sinerji')
                                  ? availableCompanies?.find((company) => company.company_code === 'Sinerji')?.status
                                    ? 'bg-green-200 text-green-700'
                                    : 'bg-red-200 text-red-700'
                                  : 'bg-gray-200 text-gray-700'
                              } rounded-full px-3 py-1 text-md font-semibold  mr-2 mb-2`}
                            >
                              {availableCompanies?.find((company) => company.company_code === 'Sinerji')
                                ? availableCompanies?.find((company) => company.company_code === 'Sinerji')?.status
                                  ? 'Uygun'
                                  : 'Uygun değil'
                                : 'Bekleniyor'}
                            </span>

                            {availableCompanies?.find((company) => company.company_code === 'Sinerji') && (
                              <>
                                <span
                                  data-tooltip-id={`tooltip-${'Sinerji'}-0`}
                                  style={{ position: 'relative', top: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <KTSVG path="/media/icons/duotone/Code/Info-circle.svg" className="svg-icon-2x svg-icon-primary" />
                                </span>
                                <Tooltip
                                  id={`tooltip-${'Sinerji'}-0`}
                                  content={
                                    availableCompanies?.find((company) => company.company_code === 'Sinerji').note
                                      ? availableCompanies?.find((company) => company.company_code === 'Sinerji').note
                                      : 'Not bulunamadı.'
                                  }
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Müşteri Bilgileri */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="card-custom border p-4 h-100 bg-gradient-light avoid-break">
                  <h4
                    className="section-title fw-bold text-primary"
                    style={{
                      fontSize: '1.8rem',
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  >
                    Bilgileriniz
                  </h4>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <strong className="text-primary">Adı Soyadı:</strong>
                        <div className="mt-1">{verifyData?.name_lastname}</div>
                      </div>
                      <div className="mb-3">
                        <strong className="text-primary">Telefon:</strong>
                        <div className="mt-1">{verifyData?.phone}</div>
                      </div>
                      <div className="mb-3">
                        <strong className="text-primary">Organizasyon Tarihi:</strong>
                        <div className="mt-1">{moment(verifyData?.organisation_date).format('DD MMMM YYYY')}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <strong className="text-primary">Organizasyon Türü:</strong>
                        <div className="mt-1">Kına Organizasyonu</div>
                      </div>
                      <div className="mb-3">
                        <strong className="text-primary">Anlaşma Tutarı:</strong>
                        <div className="mt-1 fw-bold">{verifyData?.organisation_fee?.toLocaleString('tr-TR')}₺</div>
                      </div>
                    </div>
                  </div>
                  {verifyData?.note ? (
                    <div className="mt-3">
                      <strong className="text-primary">Notlar:</strong>
                      <div className="mt-2 p-3 bg-white rounded">{verifyData?.note}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {/* Ödeme Detayları */}

            {availableCompanies?.length === 4 && availableCompanies?.filter((c: any) => c.status === true)?.length === 4 && (
              <div className="card-custom border p-4 mb-5 bg-gradient-light avoid-break">
                <h4
                  className="section-title fw-bold text-primary"
                  style={{
                    fontSize: '1.8rem',
                    fontFamily: 'Poppins, sans-serif',
                  }}
                >
                  Ödeme Detayları
                </h4>
                <div className="payment-details">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="fw-bold fs-2">Kampanyalı Tutar:</div>
                    <div className="text-end text-primary fw-bold fs-2">{verifyData?.organisation_fee?.toLocaleString('tr-TR')} ₺</div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="fw-bold fs-2">Ödenen:</div>
                    <div className="text-end text-success fw-bold fs-2">{verifyData?.total_payment?.toLocaleString('tr-TR')} ₺</div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold fs-2">Kalan Ödeme:</div>
                    <div className="text-end text-danger fw-bold fs-2">{verifyData?.remaining_payment?.toLocaleString('tr-TR')} ₺</div>
                  </div>
                  <div className="mt-3 text-end">
                    {verifyData &&
                      typeof verifyData?.remaining_payment === 'number' &&
                      verifyData?.remaining_payment > 0 &&
                      (moment(verifyData?.organisation_date)?.subtract(10, 'days')?.isBefore(moment()) ? (
                        <small className="text-danger">
                          Kalan borç en geç <strong>{moment(verifyData?.organisation_date)?.subtract(10, 'days')?.format('DD MMMM YYYY')}</strong> tarihine kadar ödenmiş olmalıydı.
                          Lütfen organizasyon firması ile iletişime geçiniz.
                        </small>
                      ) : (
                        <small>
                          Kalan borç en geç <strong>{moment(verifyData?.organisation_date)?.subtract(10, 'days')?.format('DD MMMM YYYY')}</strong> tarihine kadar ödenmiş olmalıdır.
                        </small>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default KampanyaResultPage;
